import styles from "./Company.module.css";
import johnProfile from "./JohnHeadshot.jpeg";
import gregProfile from "./GregHeadshot.jpeg";
import seanProfile from "./SeanHeadshot.jpg";
import { CompanyMemberCard } from "./CompanyMemberCard";

export const Company = () => {
  return (
    <div className={styles.container}>
      <span className={styles.headerText}>OUR FOUNDING TEAM</span>
      <div className={styles.cardContainer}>
        <CompanyMemberCard
          name="GREG KARABINOS"
          title="CO-FOUNDER"
          infoLines={[
            "10+ years of insurance experience",
            "Fellow of the CAS & Data Scientist",
          ]}
          imageSrc={gregProfile}
        />
        <CompanyMemberCard
          name="JOHN KARABINOS"
          title="CO-FOUNDER"
          infoLines={[
            "10+ years of tech experience",
            "Ex-Dropbox software engineer",
            "Startup acquired by Dropbox in 2019",
          ]}
          imageSrc={johnProfile}
        />
        <CompanyMemberCard
          name="SEAN STEPHENS"
          title="CO-FOUNDER"
          infoLines={[
            "10+ years of tech experience",
            "Ex-Dropbox & ex-Facebook software engineer",
          ]}
          imageSrc={seanProfile}
        />
      </div>
      <span className={styles.infoText}>
        With our unique combination of technological know-how and insurance
        expertise, we're the perfect team to tackle automated solutions in a
        rapidly evolving insurance industry. We build software in weeks, not
        months, and have experience harnessing LLMs for document, spreadsheet
        and image parsing.
      </span>
    </div>
  );
};
